import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 监测数据实时推送
 */
const measuringServer = {

  /**
   * 分配（获取）一个监测数据实时推送服务器
   */
  allotMeasuringRealtimeNotifyServer () {
    return axios.post(base.measuringServer.allotMeasuringRealtimeNotifyServer)
  },
}

export default measuringServer